import React, { useContext } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import Login from '../pages/Login';
import { AuthContext } from '../context/AuthContext';
import AdminRoutes from './AdminRoutes';
import UserRoutes from './UserRoutes';
import AuthProvider from '../context/AuthProvider';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/admin/*"
        element={
          <AuthProvider>
            <PrivateRoute adminRequired={true}>
              <AdminRoutes />
            </PrivateRoute>
          </AuthProvider>
        }
      />
      <Route
        path="/*"
        element={
          <AuthProvider>
            <PrivateRoute>
              <UserRoutes />
            </PrivateRoute>
          </AuthProvider>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
